import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {
    FcpAlertModule,
    FcpBadgeModule,
    FcpButtonModule,
    FcpIconModuleSVG,
    FcpLinkModule,
    FcpMenuModule
} from 'fc-ui-components';
import { TranslateModule } from '@ngx-translate/core';
import { MatSidenavModule } from '@angular/material/sidenav';

import { MobileMenuModule } from './mobile-menu/mobile-menu.module';
import { MainNavigationComponent } from './main-navigation.component';
import { ResponsiveWrapperModule } from '../responsive-wrapper/responsive-wrapper.module';
import { StoreDropdownModule } from '../../b2b-order/components/order';
import { FeatureModule } from 'components';
import { FauxInputButtonModule } from '../faux-input-button/faux-input-button.module';
import { CartModule } from '../../content/retailer-platform/cart/cart.module';
import { MainNavigationSummaryBarModule } from 'src/app/components/main-navigation/main-navigation-summary-bar/main-navigation-summary-bar.module';
import { DirectivesModule } from 'app/directives/directives.module';
import { OpenFeatureModule } from '@openfeature/angular-sdk';

const importAndExport = [MainNavigationComponent];

@NgModule({
    declarations: [...importAndExport],
    imports: [
        CommonModule,
        RouterModule,
        FcpMenuModule,
        FcpButtonModule,
        TranslateModule,
        ResponsiveWrapperModule,
        MobileMenuModule,
        DirectivesModule,
        FcpIconModuleSVG,
        StoreDropdownModule,
        FeatureModule,
        FauxInputButtonModule,
        FcpBadgeModule,
        MatSidenavModule,
        CartModule,
        MainNavigationSummaryBarModule,
        FcpAlertModule,
        FcpLinkModule,
        OpenFeatureModule
    ],
    exports: [...importAndExport]
})
export class MainNavigationModule {}
